'use client';

import { useEffect, useState } from 'react';
import HeroSection from './HeroSection';
import InteractiveMap from './InteractiveMap';
import CorporateHubsSection from './CorporateHubsSection';
import DiningSection from './DiningSection';
import TransportationSection from './TransportationSection';
import EntertainmentSection from './EntertainmentSection';
import FAQSection from './FAQSection';

const LocationGuideInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="h-[600px] bg-gradient-to-r from-primary/20 to-secondary/20 animate-pulse" />
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 space-y-8">
          <div className="h-64 bg-card rounded-xl animate-pulse" />
          <div className="h-64 bg-card rounded-xl animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <InteractiveMap />
      <CorporateHubsSection />
      <DiningSection />
      <TransportationSection />
      <EntertainmentSection />
      <FAQSection />
    </div>
  );
};

export default LocationGuideInteractive;